import Helper from './Helper';

class Accordion {
  constructor(config = {}) {
		const {
      accordionTogglerSelector,
      accordionOpenClass
		} = config;

    this.accordionTogglerSelector = accordionTogglerSelector || '.accordion__header';
    this.accordionOpenClass = accordionOpenClass || 'accordion__group--open';
    this.accordionToggler = document.querySelectorAll(this.accordionTogglerSelector);
    this.togglerArray = Array.prototype.slice.call(this.accordionToggler);

    this.bindEvents();
  }

  bindEvents() {
    this.togglerArray.forEach(toggler => {
      toggler.addEventListener('click', e => {
        this.toggleAccordion(toggler, e);
      })
    });
  }

  toggleAccordion(toggler, e) {
    const content = toggler.nextElementSibling;
    const parent = toggler.parentElement;
    Helper.toggleClass(parent, this.accordionOpenClass);
    Helper.slideToggle(content, 400);
  }
}

export default Accordion;
